import LinkifyIt from 'linkify-it'

const linkify = new LinkifyIt()

export const containsURL = text => {
  if (!text || typeof text !== 'string') return false
  const matches = linkify.match(text)

  if (matches !== null && matches.length > 0) return true

  // If the text is Bhttps://www.quark.cn/, linkify-it cannot identify it and needs to use a custom regular expression
  const linkReg = /(https?:\/\/|www\.|bit\.ly|t\.cn|tinyurl\.com|[a-zA-Z0-9-]+\.[a-zA-Z]{2,})/i
  return linkReg.test(text)
}

export const validateHostName = hostName => {
  if (!hostName) return { isValid: true }

  const hasURL = containsURL(hostName)

  return {
    isValid: !hasURL,
    hasURL
  }
}

export const validateEventName = eventName => {
  if (!eventName) return { isValid: true }

  const hasURL = containsURL(eventName)

  return {
    isValid: !hasURL,
    hasURL
  }
}
